export { default as GeneralTab }      from './GeneralSettingsTab';
export { default as OtherSettingsTab } from './OtherSettingsTab';
export { default as PincodeList }      from './PincodeList';
export { default as AddPincode }       from './AddPincode';
